module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.history.black-69cd00fbf0dcfb2de988ca822a13a310.svg";